<template>
<div>
    <div class="item_body">
        <input type="text" class="tem_input" placeholder="請輸入帳號" />
        <input type="text" class="tem_input" placeholder="請輸入密碼" />
        <div class="com_btn" @click="showMask">登入</div>
        <div class="pt200"></div>
    </div>

    <!-- <div class="mask" v-if="isMask">
        <div class="mask_tips"></div>
        <div class="mask_in">
            <i @click="closeMask"></i>
            <p>系统提示</p>
            <span>很抱歉，當前頁面服務僅對港澳台地區用戶開放</span>
        </div>
    </div> -->
</div>
</template>

<script>
export default {
    data() {
        return {
            content: ''
        }
    },
    mounted: function () {},
    methods: {
        showMask() {
            this.$emit('showMask',true);
        },
        closeMask() {
            this.isMask = false;
        }
    },
}
</script>
<style scoped>
.item_body {
    width: 400px;
    margin: 0 auto;
}
.tem_input {
    width: 100%;
    height: 50px;
    margin-bottom: 30px;
    border: none;
    outline: none;
    border-radius: 10px;
    padding: 0 10px;
    box-sizing: border-box;
    background-color: #dcdcdc;
    font-size: 16px;
}
.com_btn {
    cursor: pointer;
    width: 100%;
    height: 50px;
    line-height: 50px;
    margin-top: 30px;
    background-color: #ef653d;
    color: white;
    border-radius: 5px;
}
.pt200 {
    padding-bottom: 200px;
}
.mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    z-index: 115;
    text-align: center;
}
.mask .mask_in{
    width: 463px;
    height: 234px;
    background: #ffffff;
    position: fixed;
    left: 50%;
    top: 50%;
    margin-top: -117px;
    margin-left: -231.5px;
    border-radius: 20px;
    text-align: center;
}
.mask .mask_in i{
    width: 28px;
    height: 27px;
    position: absolute;
    right: 20px;
    top: 20px;
    background: url('../../static/img/close.png') no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
}
.mask .mask_in p {
    color:#ef6549;
    font-size: 22px;
    font-weight:600;
}
.mask .mask_in span {
    display: block;
    margin-top: 60px;
    font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/logins.vue